module.exports = __webpack_public_path__ + "static/media/atb.main.18f408a3.jpg";